import { computed, Directive, inject, input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { EytcAuthService } from '@services/index';

@Directive({
  selector: '[appAccess]',
  standalone: true,
})
export class HasRoleAccessDirective implements OnInit {
  #templateRef = inject(TemplateRef<unknown>);
  #viewContainer = inject(ViewContainerRef);
  #companyContextService = inject(EytcAuthService);

  public readonly allowedRoles = input<number[]>([], { alias: 'appAccess' });
  public readonly hideForRoles = input<number[]>([]);

  readonly #currentUserRoles = this.#companyContextService.userRoles;

  readonly #hasAllowedRoles = computed(() => {
    const userRoles = this.#currentUserRoles();

    if (userRoles.length === 0) {
      return false;
    }

    return this.allowedRoles().length === 0 || userRoles.some(role => this.allowedRoles().includes(role));
  });

  readonly #hasDeniedAccess = computed(() => {
    const userRoles = this.#currentUserRoles();

    if (userRoles.length === 0) {
      return false;
    }

    return userRoles.some(role => this.hideForRoles().includes(role));
  });

  readonly #shouldShow = computed(() => this.#hasAllowedRoles() && !this.#hasDeniedAccess());

  ngOnInit(): void {
    if (this.#shouldShow()) {
      this.#viewContainer.createEmbeddedView(this.#templateRef);
    } else {
      this.#viewContainer.clear();
    }
  }
}
